/**
 * @Author: Caroline
 * @Desc: 异步
 * @Date: 2021-3-17
 */

const actions = {

};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js